export const MAPPING_PROBLEM_FILTER = {
  ALL: "all",
  ERRORS: "errors",
  WARNINGS: "warnings",
};

export const cycleMappingProblemFilter = (current) => {
  if (current === MAPPING_PROBLEM_FILTER.ALL) {
    return MAPPING_PROBLEM_FILTER.ERRORS;
  }
  if (current === MAPPING_PROBLEM_FILTER.ERRORS) {
    return MAPPING_PROBLEM_FILTER.WARNINGS;
  }
  return MAPPING_PROBLEM_FILTER.ALL;
};

export const mappingProblemFilterButtonLabel = (filter) => {
  if (filter === MAPPING_PROBLEM_FILTER.ERRORS) {
    return "Vedi Warnings";
  }
  if (filter === MAPPING_PROBLEM_FILTER.WARNINGS) {
    return "Mostra tutto";
  }
  return "Vedi errori";
};

export const mappingProblemFilterTooltip = (filter, tooltips) => {
  if (filter === MAPPING_PROBLEM_FILTER.ERRORS) {
    return tooltips.vediWarnings;
  }
  if (filter === MAPPING_PROBLEM_FILTER.WARNINGS) {
    return tooltips.mostraTutto;
  }
  return tooltips.vediErrori;
};

export const mappingProblemFilterIsActive = (filter) => filter !== MAPPING_PROBLEM_FILTER.ALL;

export const mappingImportProblemsAvailable = (lastRunSummary, importErrorsAvailable) => {
  if (importErrorsAvailable) {
    return true;
  }
  const summary = lastRunSummary || {};
  const rowProblems = summary.row_problems || {};
  if (Object.keys(rowProblems).length > 0) {
    return true;
  }
  return Boolean(
    Object.keys(summary.row_errors || {}).length
    || Object.keys(summary.row_warnings || {}).length,
  );
};
